<template>
    <div class="modal" v-bind:class="{'is-active':isActiveManageRoleModal}">
        <div class="modal-background"></div>
        <div class="modal-card animate__animated animate__fadeIn animate__faster" style="height:80%; width: 40%">
            <header class="modal-card-head">
                <p class="modal-card-title">Manage Role</p>
                <button class="delete is-large" aria-label="close"
                        @click="openCloseManageRoleModal"></button>
            </header>


            <section class="modal-card-body" style="height: 500px">
                <div class="box">
                    <span class="title is-5">#{{roleId}}</span>. &nbsp;

                    <span class="subtitle is-5">{{roleName}}</span>
                </div>

                <div class="columns">
                    <div class="column">
                        <div class="box">
                            <span class="subtitle is-4">All Permissions</span>
                        </div>
                        <div class="level">
                            <div class="level-item">
                                <input class="input is-small" v-model="searchTextPermission"
                                       placeholder="Search all permission">

                            </div>
                            <div class="level-item">

                                <button @click="openClosePermissionModal()" class="button is-small modified-button">
                                    <span class="icon">
                                    <font-awesome-icon icon="plus"/>
                                </span>
                                    <span class="icon-text">Add Permission</span>
                                </button>

                            </div>


                        </div>
                        <div class="modified-table permission-table">
                            <table class="table is-striped is-bordered ">
                                <tbody>
                                <tr v-for="permission in searchPermissions" :key="permission.id">

                                    <td>
                                        <figure class="image is-16x16">
                                            <img src="../../assets/icons/permission.png" height="32" width="32"/>
                                        </figure>
                                    </td>
                                    <td>{{permission.name}}</td>
                                    <td>{{permission.description}}</td>
                                    <td>
                                        <font-awesome-icon @click="TryAddPermissionRole(permission.id,permission.name)"
                                                           icon="arrow-right"
                                                           size="lg" class="modified-color-blue button-hover"
                                                           style="cursor: pointer"
                                                           title="Add permission this role"
                                        />
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="column">
                        <div class="box">
                            <span class="subtitle is-4">Allowed Permissions</span>
                        </div>
                        <div class="level">
                            <div class="level-item">
                                <input class="input is-small" v-model="searchTextPermissionAllowed"
                                       placeholder="Search your permission">

                            </div>
                        </div>
                        <div class="modified-table permission-table">
                            <table class="table is-striped is-bordered ">
                                <tbody>
                                <tr v-for="rp in rolePermissions" :key="rp.id">

                                    <td>
                                        <figure class="image is-16x16">
                                            <img src="../../assets/icons/permission.png" height="32" width="32"/>
                                        </figure>
                                    </td>
                                    <td>{{rp.permissionName}}</td>
                                    <td>
                                        <font-awesome-icon @click="TryDeletePermissionRole(rp.id,rp.permissionName)"
                                                           icon="trash-alt"
                                                           size="lg" class="modified-color-red button-hover"
                                                           style="cursor: pointer"
                                                           title="Add permission this role"
                                        />
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </section>

            <footer class="modal-card-foot">
            </footer>
        </div>

        <add-permission
                :selected-role-id="roleId"
                :project-id="projectId"
                :isActiveProjectUserPermissionModal="isActiveProjectUserPermissionModal"
                @openClosePermissionModal="openClosePermissionModal"
                @setPermissionForm="openClosePermissionModal"
        />

    </div>

</template>

<script>
    import {mapState, mapActions} from "vuex"
    import AddPermission from "./AddPermission";

    export default {
        name: "ManageRole",
        props: ['isActiveManageRoleModal', 'roleId', 'roleName', 'projectId'],
        components: {
            AddPermission,
        },
        data() {
            return {
                searchTextPermission: "",
                searchTextPermissionAllowed: "",
                isActiveProjectUserPermissionModal: false,
                rolePermissionForm: {
                    id: 0,
                    roleId: 0,
                    permissionId: 0
                },
            }
        },
        methods: {
            ...mapActions('roles', ['getPermissions', 'getRolePermissions', 'addRolePermission', 'deleteRolePermission']),

            async openCloseManageRoleModal() {
                this.$emit('openCloseManageRoleModal');
            },
            async openClosePermissionModal() {
                this.isActiveProjectUserPermissionModal = !this.isActiveProjectUserPermissionModal
            },

            async TryAddPermissionRole(id, name) {
                await this.$swal({
                    title: '<p style="font-size: 22px; font-family: Poppins;text-align: center">You are about to add this permission "' + name + '" . Are you sure?</p>',
                    html: "",
                    showCancelButton: true,
                    cancelButtonText: 'No',
                    cancelButtonColor: '#ec2929d4',
                    confirmButtonColor: '#1e3e67',
                    confirmButtonText: 'Yes',
                }).then(async (response) => {
                    if (response.value) {
                        try {
                            this.rolePermissionForm.roleId = this.roleId;
                            this.rolePermissionForm.permissionId = id;
                            await this.addRolePermission(this.rolePermissionForm);
                            await this.getRolePermissions(this.roleId);
                            this.$notify({
                                title: "Success",
                                text: "Permission adding successfully. ",
                                type: "success"
                            });

                        } catch (e) {
                            this.$notify({
                                title: "Error",
                                text: "Failed to adding permission.." + e.message,
                                type: "error"
                            });
                        }
                    }
                });
            },
            async TryDeletePermissionRole(id, name) {
                await this.$swal({
                    title: '<p style="font-size: 22px; font-family: Poppins;text-align: center">You are about to delete this permission "' + name + '" in this role. Are you sure?</p>',
                    html: "",
                    showCancelButton: true,
                    cancelButtonText: 'No',
                    cancelButtonColor: '#ec2929d4',
                    confirmButtonColor: '#1e3e67',
                    confirmButtonText: 'Yes',
                }).then(async (response) => {
                    if (response.value) {
                        try {
                            await this.deleteRolePermission(id)
                            await this.getRolePermissions(this.roleId);
                            this.$notify({
                                title: "Success",
                                text: "Permission has been deleted successfully. ",
                                type: "success"
                            });

                        } catch (e) {
                            this.$notify({
                                title: "Error",
                                text: "Failed to deleting permission.." + e.message,
                                type: "error"
                            });
                        }
                    }
                });
            },
        },
        computed: {
            ...mapState('roles', ['permissions', 'rolePermissions']),

            filteredPermission: function () {
                return this.permissions.filter(i => !this.rolePermissions.find(j => j.permissionId == i.id))
            },

            searchPermissions: function () {

                return this.filteredPermission.filter((post) => {
                    return post.name.toUpperCase().match(this.searchTextPermission.toUpperCase());
                })
            },
        },
        mounted() {
            document.body.addEventListener('keyup', e => {
                if (e.keyCode === 27) {
                    this.isActiveManageRoleModal = false;
                }
            })
        },
    }
</script>

<style scoped>
    .permission-table {
        font-size: 10px;
        max-height: 430px;
    }

    .permission-table tbody tr {
        background-color: #2b5d9c61;
    }

</style>
